import styled from '@emotion/styled'
import type { MouseEventHandler } from 'react'

import { Card } from '@/components/Card'
import { CONFIG } from '@/styles/emotion.config'

export interface BlogCardStylesProps {
  modifier: 'large' | 'default' | 'horizontal'
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

export const BlogCardStyles = styled(Card)<BlogCardStylesProps>(
  `
  &,
  .blog-card__content {
    display: flex;
    flex: 1;
  }

  .blog-card__cover {
    position: relative;
    overflow: hidden;
  }

  .blog-card__cover img {
    object-fit: cover;
  }

  .blog-card__title {
    margin: 0 0 auto;
  }

  .blog-card__content {
    flex-direction: column;
    padding: 1rem;
  }
  `,
  (props) =>
    props.modifier === 'default' &&
    `
    flex-direction: column;
    min-height: 18rem;
`,
  (props) =>
    props.modifier === 'horizontal' &&
    `
    padding: 0.5rem;
    flex-direction: row;

    .blog-card__cover {
      border-radius: var(--theme-border-radius);
    }

    > * {
      flex: 1;
      margin: 0.5rem;
      padding: 0;
    }

    .blog-card__content {
      padding: 0;
    }

    ${CONFIG.media.mobileLg} {
      .blog-card__cover {
        display: none;
      }
    }
`,
  (props) =>
    props.modifier === 'large' &&
    `
    flex-direction: column;

    ${CONFIG.media.lg} {
      .blog-card__cover {
        height: 40%;
      }
    }
`,
)
